import { motion } from "framer-motion";
import { Undo2 } from "lucide-react";
import { formatDate } from "./useReviewData";

const ACTION_COLORS = {
  create: "text-green-400",
  approve: "text-green-400",
  edit: "text-blue-400",
  override: "text-blue-400",
  delete: "text-red-400",
  activate: "text-yellow-400",
  clear_override: "text-yellow-400",
};

const ActionHistorySection = ({ history, onUndo }) => (
  <motion.section
    initial={{ opacity: 0, y: 16 }}
    animate={{ opacity: 1, y: 0 }}
    className="mt-8 hud-card clip-corners p-6"
    data-testid="action-history-section"
  >
    <h2 className="font-headings text-2xl uppercase tracking-widest text-white mb-4">
      Action History
    </h2>
    {history.length === 0 ? (
      <p className="text-sm text-gray-400">No actions recorded yet.</p>
    ) : (
      <div className="space-y-2 max-h-96 overflow-y-auto">
        {history.map((entry) => {
          const canUndo = !entry.reverted_at && onUndo;
          return (
            <div
              key={entry.id}
              className="border border-white/10 p-3 text-xs"
              data-testid={`history-${entry.id}`}
            >
              <div className="flex items-center justify-between gap-2">
                <div className="flex items-center gap-3 min-w-0">
                  <span
                    className={`font-data ${ACTION_COLORS[entry.action] || "text-white"}`}
                  >
                    {entry.action.toUpperCase()}
                  </span>
                  <span className="text-gray-400 truncate">
                    {entry.snapshot?.name || entry.stratagem_id}
                  </span>
                </div>
                <div className="flex items-center gap-2 shrink-0">
                  <span className="text-gray-500">
                    {formatDate(entry.created_at)}
                  </span>
                  {canUndo && (
                    <button
                      onClick={() => onUndo(entry.stratagem_id, entry.snapshot?.name)}
                      className="flex items-center gap-1 border border-yellow-500/40 px-2 py-1 text-yellow-400 hover:border-yellow-500 hover:bg-yellow-500/10"
                      title={`Undo ${entry.action} on ${entry.snapshot?.name || entry.stratagem_id}`}
                      data-testid={`undo-${entry.id}`}
                    >
                      <Undo2 className="h-3 w-3" />
                      Undo
                    </button>
                  )}
                </div>
              </div>
              {entry.reverted_at && (
                <p className="text-yellow-400 mt-1">
                  Reverted at: {formatDate(entry.reverted_at)}
                </p>
              )}
            </div>
          );
        })}
      </div>
    )}
  </motion.section>
);

export default ActionHistorySection;
